<template lang="pug">
.paletta
  .paletta-intro
    AppTitle.u-mb-0(:title="$t('mantra')")

    img.paletta-intro-img(src='https://cdn.baianat.com/static/paletta/1.png', srcset='https://cdn.baianat.com/static/paletta/1.png 1x, https://cdn.baianat.com/static/paletta/1@2x.png 2x')

  section.u-mt-lg.paletta-items
    Query.grid.is-desktop-4.is-widescreen-3.is-tablet-6.is-mb(
      :query="require('~/graphql/Palette.gql').Palettes"
      :initialValue="palettes"
      :limit="12"
      v-slot="{ items }"
    )
      .column(v-for="node in items")
        .paletta-card(@click="selectPallette(node)")
          h5.paletta-card-title {{ node.name }}
          .paletta-colors
            .paletta-colors-item(v-for="color in node.colors" :style="{ background: color.value }")

  Overlay(:is-open.sync="selectedPalette" centered)
    .grid.is-ultrawide-4.is-widescreen-6.is-desktop-7.is-tablet-9.is-center.u-textCenter.u-mh-xs
      .column(v-if="selectedPalette")
        h3 {{ selectedPalette.name }}
        .paletta-colors.u-mh-sm.paletta-download(ref="download")
          .paletta-colors-item.is-tall.has-text(v-for="color in selectedPalette.colors" :style="{ background: color.value }" @click="clip(color.value)")
            span {{ color.value }}
            //- span {{ color.value }} {{ color.ratio }}%
        .paletta-share.u-mb-xs
          ShareButton(provider="facebook")
          ShareButton(provider="twitter" :text="selectedPalette.name")

        button.button.is-rounded.is-wide.is-inverse(@click.prevent="downloadImage(selectedPalette.name)") {{ $t('download') }}

  .u-mb-mi

</template>

<script>
let html2canvas = null;
if (process.browser) {
  html2canvas = require('html2canvas');
}
import { mapActions } from 'vuex';
import { Palettes } from '~/graphql/Palette.gql';
import { load } from '~/directives';
import ShareButton from '~/components/ShareButton';
import { copyToClipboard } from '~/utils/common';
import { generateSeoMeta } from '~/utils/seo';
import Overlay from '~/components/Overlay';
import Query from '~/components/Query';

export default {
  scrollToTop: true,
  meta: {
    theme: 'paletta',
    logoText: 'palettes'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  components: {
    ShareButton,
    Overlay,
    Query
  },
  directives: { load },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Palettes,
      variables: {
        first: 12
      }
    });

    return {
      palettes: data.palettes
    };
  },
  data: () => ({
    selectedPalette: null
  }),
  methods: {
    ...mapActions({
      success: 'alert/success'
    }),
    selectPallette(item) {
      this.selectedPalette = item;
    },
    clip(str) {
      copyToClipboard(str);
      // Notify when copy
      this.success(this.$t('copied'));
      this.$emit('success');
    },
    downloadImage(name) {
      let xprint = this.$refs.download;
      html2canvas(xprint).then(canvas => {
        this.downloadCanvas(canvas, `${name}.png`);
      });
    },
    downloadCanvas(canvas, filename) {
      const a = document.createElement('a');
      a.href = canvas.toDataURL();
      a.download = filename;
      a.click();
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Palettes",
    "pageDesc":"Vibrant color palettes that are ready for instant download and use in your branding, web or any other design projects.",
    "copied": "Copied to clipboard",
    "mantra":"Colors for |every mood.",
    "download":"Download"
  },
  "ar": {
    "pageTitle":"بالتة",
    "pageDesc":"تفقد لوحات ألوان مذهلة مجانية و متاحة للتحميل والاستخدام على الفور في تصميماتك سواء في العلامة التجارية أو تصميم الموقع",
    "copied": "تم نسخ اللون",
    "mantra":"ألوان متناسقة |لكل تصميم.",
    "download":"تحميل"
  }
}
</i18n>
